import React from 'react';
import { CmsValue } from 'core/type/BootstrapConfig.types';
import { PaxCounterProps } from 'component/page/detail/PackageOptions/ExpandedOffer/OfferCardPaxPanel/PaxCounter/paxUtils';
import { SummaryElement } from 'gql/autogen/SummaryElement';
import { PriceFormatter, StringFormatter } from '@agoda/react-handyman';
import { Box, Typography } from '@drone-js/core';

export interface SummaryPaxInfoTextProps {
    cms: CmsValue;
    paxCounter: PaxCounterProps;
    pricePerPaxList: SummaryElement[];
    currency: string | undefined;
    locale: string;
}

const SummaryPaxInfoText: React.FC<SummaryPaxInfoTextProps> = (props) => {
    const { cms, paxCounter, currency, pricePerPaxList, locale } = props;
    const { title, amount } = paxCounter;
    const pricePerPax = pricePerPaxList.find((price) => price.displayType === paxCounter.paxType);
    const chargeTotal = pricePerPax?.total?.allInclusive?.chargeTotal;

    if (amount <= 0) {
        return null;
    }

    const priceText =
        chargeTotal !== undefined
            ? PriceFormatter.format(chargeTotal, locale, {
                  isSpaceBetweenSymbolAndCurrency: true,
                  decimalPlaces: 2,
                  currency,
              })
            : undefined;

    const displayAmount = priceText ? StringFormatter.format(cms[337157], priceText, amount) : amount;

    return (
        <Box display="flex" justifyContent="space-between" width="100%" pb="12" data-testid="summary-pax-info-text">
            <Typography variant="body-s-strong">{title}</Typography>
            <Typography variant="body-s">{displayAmount}</Typography>
        </Box>
    );
};

SummaryPaxInfoText.displayName = 'PaxInfoText';

export default SummaryPaxInfoText;
